<template>
    <div>
  
      <base-header class="pb-6 bg-light">
  
        <b-row align-v="center" class="py-4">
          <b-col cols="7" lg="6">
            <h6 class="h2 d-inline-block mb-0 text-dark">No Design</h6>
          </b-col>
          <b-col cols="5" lg="6" class="text-right">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </b-col>
        </b-row>
  
      <b-row>
  
        <b-col>
  
          <b-card>
            <b-card-body>
              <p align="center">
                <img v-bind:src="pageLogo" :style="logoStyle" class="navbar-brand-img"><br>
              </p>
              <p>
                No Designed yet
              </p>
             
            </b-card-body>
          </b-card>
  
        </b-col>
      </b-row>
  
      </base-header>
  
    </div>
  </template>
  <script>
  import RouteBreadCrumb from '../../components/Breadcrumb/RouteBreadcrumb';
  
  export default {
    components: {
      RouteBreadCrumb,
    },
    data() {
      return {
        pageTitle: '',
        pageLogo: '',
        logoStyle: '',
      };
    },
    mounted() {
      this.pageTitle = process.env.VUE_APP_CLIENT.toString().toUpperCase()+' Portal'
      this.pageLogo = '/img/brand/'+process.env.VUE_APP_CLIENT.toString() +'.png';
      let width = `137px`;
      let height = `96px`;
      this.logoStyle = `width: ${width}; `;
    }
  
  };
  
  </script>
  